var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mail-title" },
    [
      _c("h1", { staticClass: "mail-subject" }, [_vm._v(_vm._s(_vm.subject))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "title-actions" },
        [
          _c(
            "div",
            { staticClass: "mail-actions" },
            [
              _c("a-tooltip", { attrs: { title: "Yanıtla" } }, [
                _c(
                  "div",
                  {
                    staticClass: "action-button",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("reply")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("reply"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-dropdown",
                {
                  attrs: {
                    trigger: ["click"],
                    placement: "bottomRight",
                    overlayClassName: "custom-mail-dropdown",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "overlay",
                      fn: function () {
                        return [
                          _c(
                            "a-menu",
                            [
                              _vm.refVisitorId
                                ? _c(
                                    "a-menu-item",
                                    {
                                      key: "reply",
                                      on: { click: _vm.createMailTask },
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("assignment")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Görev Oluştur")]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a-menu-item",
                                {
                                  key: "ai-sentiment",
                                  staticClass: "ai-menu-item",
                                  on: { click: _vm.handleSentimentAnalysis },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "ai-tool-menu-item" },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("psychology")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("AI Duygu Analizi")]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-menu-item",
                                {
                                  key: "ai-summary",
                                  staticClass: "ai-menu-item",
                                  on: { click: _vm.handleSummarize },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "ai-tool-menu-item" },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("summarize")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("AI Özet Oluştur")]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.hasMultipleRecipients
                                ? _c(
                                    "a-menu-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit("reply-all")
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("reply_all")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Tümünü Yanıtla")]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a-menu-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("forward")
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("forward"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Yönlendir")]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("a-menu-divider"),
                              _vm._v(" "),
                              _c("a-menu-divider"),
                              _vm._v(" "),
                              _c(
                                "a-menu-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("delete-thread")
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("delete"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Sil")]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("a-tooltip", { attrs: { title: "Daha Fazla" } }, [
                    _c("div", { staticClass: "action-button" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("more_vert"),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-tooltip", { attrs: { title: "İçeriği Kapat" } }, [
            _c(
              "div",
              {
                staticClass: "action-button",
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    style: { color: "#22272d" },
                  },
                  [_vm._v("close")]
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showAIAssistant
        ? _c("MailAIAssistant", {
            attrs: {
              mode: _vm.aiAssistantMode,
              autoRun: true,
              useCloseButton: true,
              threadMails: _vm.threadMails,
            },
            on: {
              close: function ($event) {
                _vm.showAIAssistant = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }